export default {
  "@global html": {
    height: '100%',
    background: '#f1f1f1'
  },
  "@global body": {
    height: '100%',
    background: '#f1f1f1'
  },
  "@global center": {
    height: '300px',
    width: '200px',
    margin: '0 auto'
  },
  containerSteps: {
    width :"100%"
  }
};
